"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceTaxonomyTargetToJSON = exports.AudienceTaxonomyTargetFromJSONTyped = exports.AudienceTaxonomyTargetFromJSON = exports.instanceOfAudienceTaxonomyTarget = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AudienceTaxonomyTarget interface.
 */
function instanceOfAudienceTaxonomyTarget(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceTaxonomyTarget = instanceOfAudienceTaxonomyTarget;
function AudienceTaxonomyTargetFromJSON(json) {
    return AudienceTaxonomyTargetFromJSONTyped(json, false);
}
exports.AudienceTaxonomyTargetFromJSON = AudienceTaxonomyTargetFromJSON;
function AudienceTaxonomyTargetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'fullName': !(0, runtime_1.exists)(json, 'full_name') ? undefined : json['full_name'],
        'children': !(0, runtime_1.exists)(json, 'children') ? undefined : (json['children'].map(AudienceTaxonomyTargetFromJSON)),
    };
}
exports.AudienceTaxonomyTargetFromJSONTyped = AudienceTaxonomyTargetFromJSONTyped;
function AudienceTaxonomyTargetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'full_name': value.fullName,
        'children': value.children === undefined ? undefined : (value.children.map(AudienceTaxonomyTargetToJSON)),
    };
}
exports.AudienceTaxonomyTargetToJSON = AudienceTaxonomyTargetToJSON;
